var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "contents",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:red;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, "\u30A2\u30FC\u30C8\u30DC\u30FC\u30C9 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 75,
    height: 75,
    rx: 11.338583,
    id: "rect8",
    x: 0,
    y: 0,
    ry: 11.338583,
    style: {
      stroke: "#000000",
      strokeOpacity: 1,
      strokeWidth: 0.1,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      fill: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/None.41d69ab0aafb199267df9a872b63b4d7.svg";
export { ForwardRef as ReactComponent };